<template>
  <div>
    <div class="header">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link
            to="/seller-management"
            style="font-weight: bold; color: #a6a6a6; font-size: 18px"
            >Seller Management</router-link
          >
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link
            :to="`/sellers/${sellerId}`"
            style="font-weight: bold; color: #a6a6a6; font-size: 18px"
          >
            Seller Detail View</router-link
          >
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <span
            style="font-weight: bold; color: #000; font-size: 18px"
          >
            Factoring Request view</span
          >
        </a-breadcrumb-item>
      </a-breadcrumb>

      <!-- Card -->
      <a-card class="factoring-request-card" :bordered="false">
        <!-- Request Overview -->
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>
            <h1 style="font-size: large; font-weight: 700">
              Factoring Finance Requests
            </h1>
            <p style="color: #6b7280; font-size: 14px">
              View and manage seller's Factoring requests
            </p>
          </div>

          <div style="display: flex; align-items: center; gap: 16px">
            <!-- <a-button
              :loading="exportLoading"
              @click="exportExcell"
              style="border-radius: 6px; background: #f9fafb; color: #374151"
              icon="block"
            >
              Suspend
            </a-button> -->
            <a-button
              :loading="exportLoading"
              @click="exportExcell"
              style="border-radius: 6px; background: #26a246; color: #ffffff"
              icon="download"
            >
              Export
            </a-button>
          </div>
        </div>

        <a-divider orientation="left" />

        <h1 style="font-size: 18px; font-weight: 700; margin-bottom: 20px">
          Request Overview
        </h1>

        <a-row :gutter="[16, 16]">
          <a-col :span="8">
            <div class="text-sm text-gray-500">Request ID</div>
            <div style="font-weight: 600; color: #000; margin-top: 4px">
              {{ requestData.requestId }}
            </div>
          </a-col>
          <a-col :span="8">
            <div class="text-sm text-gray-500">Submitted by</div>
            <div
              style="
                display: flex;
                align-items: center;
                gap: 4px;
                margin-top: 4px;
              "
            >
              <a-avatar
                size="large"
                :style="{
                  backgroundColor: color,
                  verticalAlign: 'middle',
                  color: '#047857',
                }"
                :gap="gap"
                :src="requestData.sellerImage"
                :alt="buyerNameInitials"
                class="avatar"
              >
                {{ buyerNameInitials }}
              </a-avatar>
              <p style="margin: 0">{{ requestData.buyerName }}</p>
            </div>
          </a-col>

          <a-col :span="8">
            <div class="text-sm text-gray-500" style="margin-bottom: 4px">
              Status
            </div>
            <a-button :style="statusButtonStyle" type="primary">
              {{ requestData.status }}
            </a-button>
          </a-col>
        </a-row>

        <a-divider orientation="left" />

        <a-row :gutter="[16, 16]">
          <a-col :span="8">
            <div class="label">Linked Invoice</div>
            <a-button type="link" 
              @click="showInvoiceDetails"
              style="font-weight: 600; color: #26a246; padding: 0"
              :disabled="!requestData.invoiceNumber"
           >{{
              requestData.invoiceNumber
            }}</a-button>
            <div class="description"></div>
          </a-col>
          <a-col :span="8">
            <div class="label">Invoice Value</div>
            <div class="description">
              {{ formatAmount(requestData.invoiceValue) }}
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="[16, 16]">
          <a-col :span="8">
            <div class="label">Buyer Name</div>
            <div class="description">{{ requestData.buyerName }}</div>
          </a-col>
          <a-col :span="8">
            <div class="label">Requested Amount</div>
            <div class="description">
              {{ formatAmount(requestData.requestedAmount) }}
            </div>
          </a-col>
        </a-row>
      </a-card>
    </div>

    <a-card class="financing-terms-card" :bordered="true">
      <h1 style="font-size: 18px; font-weight: 700; margin-bottom: 20px">
        Financing Terms
      </h1>

      <a-row :gutter="[16, 16]" align="middle" justify="space-between">
        <a-col :span="8">
          <div class="label">Final Fee</div>
          <a-input v-model="requestData.fee" addon-after="%" disabled />
        </a-col>

        <a-col :span="8">
          <div class="label">Repayment Due Date</div>
          <a-date-picker
            v-model="requestData.repaymentDate"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            style="width: 100%"
          />
        </a-col>
      </a-row>
      <a-row :gutter="[16, 16]" align="middle" justify="space-between">
        <a-col :span="8">
          <div class="label">Net Payout Amount</div>
          <a-input
            :value="formatAmount(requestData.requestedAmount)"
            addon-after=""
            disabled
          />
        </a-col>

        <a-col :span="8">
          <div class="label">Payment Schedule</div>
          <a-select v-model="requestData.paymentSchedule" style="width: 100%">
            <a-select-option value="one-time">One time payment</a-select-option>
            <a-select-option value="monthly">Monthly</a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </a-card>

    <a-row :gutter="[16, 16]" align="middle" justify="space-between">
      <a-col :span="12">
        <a-card class="financing-terms-card" :bordered="true">
          <h1 style="font-size: large; font-weight: 700">Seller Information</h1>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <div class="label">Seller Type:</div>
            <div class="description">{{ requestData.sellerInfo.type }}</div>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <div class="label">Region:</div>
            <div class="description">{{ requestData.sellerInfo.region }}</div>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <div class="label">Previous Disbursements:</div>
            <div class="description">
              {{ requestData.sellerInfo.disbursements }}
            </div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card class="financing-terms-card" :bordered="true">
          <h1 style="font-size: large; font-weight: 700">Buyer Information</h1>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <div class="label">Credit Score:</div>
            <div class="description">
              {{ requestData.buyerInfo.creditScore }}
            </div>
          </div>

          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <div class="label">Risk Level</div>
            <a-tag
              :color="
                requestData.buyerInfo.riskLevel === 'Low Risk' ? 'green' : 'red'
              "
            >
              {{ requestData.buyerInfo.riskLevel }}
            </a-tag>
          </div>

          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <div class="label">Payment History</div>
            <div class="description">
              {{ requestData.buyerInfo.paymentHistory }}
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>

    <!-- Compliance Checklist -->
    <!-- <a-row :gutter="[16, 16]" align="middle" justify="space-between">
      <a-col :span="12">
        <a-card class="financing-terms-card" :bordered="true">
          <h1 style="font-size: large; font-weight: 700">
            Compliance Checklist
          </h1>
          <a-list
            :border="false"
            :data-source="checklistItems"
            class="mb-6"
            style="margin-top: 20px"
          >
            <template #renderItem="item">
              <div
                :style="{
                  backgroundColor: item.checked ? '#d1fae5' : '#f3f4f6',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  marginBottom: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }"
              >
                <div style="display: flex; align-items: center;">
                  <a-checkbox
                    :checked="item.checked"
                    @change="(e) => handleCheckboxChange(item, e.target.checked)"
                    :disabled="!isAdmin"
                  />
                  <span style="margin-left: 8px">{{ item.label }}</span>
                </div>
                <a-tag :color="item.checked ? 'green' : 'orange'">
                  {{ item.checked ? 'Verified' : 'Pending' }}
                </a-tag>
              </div>
            </template>
          </a-list>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card class="financing-terms-card" :bordered="true">
          <h1 style="font-size: large; font-weight: 700">Audit Logs</h1>
          <div style="display: flex; flex-direction: column; gap: 12px;">
            <div v-for="(log, index) in requestData.auditLogs" :key="index" style="display: flex; align-items: flex-start; gap: 16px;">
              <a-avatar
                size="small"
                style="margin-top: 2px; background-color: #d1fae5; color: #047857; font-weight: bold;"
              >
                {{ log.author ? log.author.split(' ').map(n => n[0]).join('').toUpperCase() : '' }}
              </a-avatar>
              <div style="flex: 1;">
                <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 2px;">
                  <span style="font-weight: 500; color: #444;">{{ log.author }}</span>
                  <span style="color: #bdbdbd; font-size: 13px;">{{ formatInvoiceDate(log.datetime) }}</span>
                </div>
                <div style="font-size: 14px; color: #444;">{{ log.note }}</div>
              </div>
            </div>
          </div>
          <a-textarea placeholder="Add a note..." class="mb-4 mt-2" v-model="note" />
          <a-button type="primary" @click="addNote" style="background-color: #26a246;border: none;">Submit Note</a-button>
        </a-card>
      </a-col>
    </a-row> -->

    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      "
    >
      <a-button @click="goBack">Back</a-button>

      <div style="display: flex; gap: 16px">
        <a-button type="default" @click="showDrawer" :disabled="requestData.status === 'Approved'"
          :style="requestData.status === 'Approved' ? { background: '#f5f5f5', color: '#4B5563', border: '1px solid #bfbfbf', cursor: 'not-allowed' } : {}"
        >Edit Terms</a-button>
        <a-button
          type="primary"
          :disabled="requestData.status === 'Approved'"
          @click="handleApprove"
          :style="(requestData.status === 'Approved') ? {
            borderRadius: '6px',
            background: '#f5f5f5',
            color: '#4B5563',
            border: '1px solid #bfbfbf',
            cursor: 'not-allowed'
          } : {
            borderRadius: '6px',
            background: '#26a246',
            color: '#ffffff',
            border: 'none',
            cursor: 'pointer'
          }"
        >Approve</a-button>
        <a-button
          type="primary"
          danger
          :disabled="requestData.status === 'Approved'"
          @click="reject"
          :style="(!allItemsChecked || requestData.status === 'Approved') ? {
            background: '#f5f5f5',
            color: '#4B5563',
            borderRadius: '6px',
            border: '1px solid #bfbfbf',
            cursor: 'not-allowed'
          } : {
            background: '#ff0000',
            color: '#ffffff',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer'
          }"
        >Reject</a-button>
      </div>
    </div>

    <EditTermsDrawer
      :visible.sync="drawerVisible"
      :requestData="requestData"
      @update-terms="handleTermsUpdate"
    />
    <InvoiceFactoringRequest
      :visible="invoiceModalVisible"
      :requestData="requestData"
      @ok="handleInvoiceDecision"
      @close="invoiceModalVisible = false"
    />

    <a-modal
      :visible="showInvoiceModal"
      :footer="null"
      @cancel="showInvoiceModal = false"
      width="900px"
    >
      <div class="invoice-modal" ref="invoiceRef">
        <div class="invoice-header" style="display: flex; justify-content: space-between; align-items: flex-start;">
          <div>
            <h2>INVOICE</h2>
            <div>Invoice Number: INV-{{ requestData.invoiceNumber }}</div>
            <div>Date: {{ formatInvoiceDate(requestData.invoiceResponse && requestData.invoiceResponse.createdAt) }}</div>
            <div>Due Date: {{ formatInvoiceDate(requestData.invoiceResponse && requestData.invoiceResponse.dueDate) }}</div>
          </div>
          <div>
            <a-tag color="green" v-if="requestData.status === 'Approved'">Approved</a-tag>
            <a-tag color="orange" v-else>{{ requestData.status }}</a-tag>
          </div>
        </div>
       
        <div class="invoice-addresses" style="display: flex; justify-content: space-between; margin: 24px 0;">
          <div>
            <b>From:</b><br>
            <template v-if="sellerDetailsLoading">
              <a-spin size="small" /> Loading seller info...
            </template>
            <template v-else-if="sellerDetailsError">
              <span style="color: red">{{ sellerDetailsError }}</span>
            </template>
            <template v-else>
              {{ sellerDetails && sellerDetails.businessDetails && sellerDetails.businessDetails.businessName }}<br>
              {{ sellerDetails && sellerDetails.businessAddress && sellerDetails.businessAddress.addressLine1 }},
              {{ sellerDetails && sellerDetails.businessAddress && sellerDetails.businessAddress.cityTown }}<br>
              {{ sellerDetails && sellerDetails.accountDetails && sellerDetails.accountDetails.accountEmail }}
            </template>
          </div>
          <div>
            <b>To:</b><br>
            {{ requestData.invoiceResponse && requestData.invoiceResponse.customerBusinessName }}<br>
            {{ requestData.invoiceResponse && requestData.invoiceResponse.customerAddress }}<br>
            {{ requestData.invoiceResponse && requestData.invoiceResponse.customerCity }}, {{ requestData.invoiceResponse && requestData.invoiceResponse.customerCountry }}
          </div>
        </div>
         <!-- Product Details -->
          <!-- Product Details Table in Modal -->
          <div style="margin: 24px 0">
          <template v-if="productDetailsLoading">
            <a-spin size="small" /> Loading product details...
          </template>
          <template v-else-if="productDetailsError">
            <span style="color: red">{{ productDetailsError }}</span>
          </template>
          <template v-else>
            <a-table
              :columns="[
                { title: 'Product Name', dataIndex: 'productName', key: 'productName' },
                { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
                { title: 'Unit Price', dataIndex: 'price', key: 'price', customRender: (text) => formatAmount(text) },
                { title: 'Total', key: 'total', customRender: (text, record) => formatAmount(record.quantity * record.price) }
              ]"
              :data-source="productDetails"
              :pagination="false"
              rowKey="productName"
            />
          </template>
        </div>
        <!-- Invoice Summary under Product Table -->
        <div class="invoice-summary" style="text-align: right; margin: 24px 0px; gap: 20px; display: flex; flex-direction: column;">
          <div>Subtotal: <b>{{ formatAmount(productDetails.reduce((sum, p) => sum + (p.quantity * p.price), 0)) }}</b></div>
          <div>Fees & Charges ({{ requestData.fee }}%): <b>{{ formatAmount(productDetails.reduce((sum, p) => sum + (p.quantity * p.price), 0) * (requestData.fee / 100)) }}</b></div>
          <div style="font-size: 16px;">Total Due: <b>{{ formatAmount(productDetails.reduce((sum, p) => sum + (p.quantity * p.price), 0) * (1 + (requestData.fee / 100))) }}</b></div>
        </div>
        <!-- Payment instructions section -->
        <div class="invoice-payment" style="background: #f9fafb; border-radius: 8px; padding: 16px; margin-bottom: 24px; ">
          <b>Payment Instructions</b>
          <template v-if="sellerDetailsLoading">
            <a-spin size="small" /> Loading payment info...
          </template>
          <template v-else-if="sellerDetailsError">
            <span style="color: red">{{ sellerDetailsError }}</span>
          </template>
          <template v-else>
            <div style="display: flex; gap: 40px; margin-top: 8px; justify-content: space-between;">
              <div>
                <div style="color: #1a1a1a; font-weight: bolder;">Bank Transfer</div>
                <div>Bank: {{ sellerDetails && sellerDetails.paymentInformation && sellerDetails.paymentInformation.bankDetails && sellerDetails.paymentInformation.bankDetails.bankName }}</div>
                <div>Account Name: {{ sellerDetails && sellerDetails.paymentInformation && sellerDetails.paymentInformation.bankDetails && sellerDetails.paymentInformation.bankDetails.accountName }}</div>
                <div>Account Number: {{ sellerDetails && sellerDetails.paymentInformation && sellerDetails.paymentInformation.bankDetails && sellerDetails.paymentInformation.bankDetails.accountNumber }}</div>
                <div>SWIFT: {{ sellerDetails && sellerDetails.paymentInformation && sellerDetails.paymentInformation.bankDetails && sellerDetails.paymentInformation.bankDetails.swiftCode }}</div>
              </div>
              <div>
                <div style="color: #1a1a1a; font-weight: bolder;">Mobile Money</div>
                <div>Number: {{ sellerDetails && sellerDetails.paymentInformation && sellerDetails.paymentInformation.mobileMoneyDetails && sellerDetails.paymentInformation.mobileMoneyDetails.mobileMoneyRegisteredNumber }}</div>
                <div>Business Name: {{ sellerDetails && sellerDetails.paymentInformation && sellerDetails.paymentInformation.mobileMoneyDetails && sellerDetails.paymentInformation.mobileMoneyDetails.mobileMoneyRegisteredName }}</div>
              </div>
              <div></div>
            </div>
          </template>
        </div>
       
      </div>
      <a-button type="primary" style="margin-top: 8px; background-color: #26a246; border:none" @click="downloadInvoice">Download</a-button>
    </a-modal>
  </div>
</template>
<script>
import EditTermsDrawer from "./EditTerms.vue";
import InvoiceFactoringRequest from "./InvoiceFactoringRequest.vue";
import sellersService from "@/api/sellers.service.js";
import * as XLSX from 'xlsx';
import html2pdf from 'html2pdf.js';
import { formatAmount } from "../../utils";

export default {
  name: "FactoringRequestView",
  components: {
    EditTermsDrawer,
    InvoiceFactoringRequest,
  },

  props: {
    sellerId: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
      description: "Invoice number"
    },
  },
  data() {
    return {
      invoiceId: this.id,
      requestData: {
        requestId: "",
        invoiceNumber: "",
        invoiceValue: 0,
        requestedAmount: 0,
        buyerName: "",
        fee: 0,
        repaymentDate: null,
        paymentSchedule: "",
        status: "",
        sellerInfo: {
          type: "",
          region: "",
          disbursements: 0,
        },
        buyerInfo: {
          creditScore: "",
          riskLevel: "",
          paymentHistory: "",
        },
        auditLogs: [],
        sellerImage: "",
        invoiceResponse: {},
      },
      checklistItems: [
        { 
          label: "Seller KYC Verified", 
          checked: false
        },
        { 
          label: "Invoice Verified", 
          checked: false
        },
        { 
          label: "Buyer Credit Score Passed", 
          checked: false
        },
        { 
          label: "Buyer Has Overdue Invoice", 
          checked: false
        },
      ],
      drawerVisible: false,
      invoiceModalVisible: false,
      selectedInvoiceRequest: null,
      loading: false,
      error: null,
      exportLoading: false,
      color: "#d1fae5",
      gap: 4,
      isApproved: false,
      isAdmin: true, // Set this based on user role
      showInvoiceModal: false,
      invoiceColumns: [
        { title: 'Product Name', dataIndex: 'productName', key: 'productName' },
        { title: 'SKU', dataIndex: 'sku', key: 'sku' },
        { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
        { title: 'Unit Price', dataIndex: 'unitPrice', key: 'unitPrice', customRender: (text) => `$${Number(text).toFixed(2)}` },
        { title: 'Total', dataIndex: 'total', key: 'total', customRender: (text) => `$${Number(text).toFixed(2)}` }
      ],
      sellerDetails: null,
      sellerDetailsLoading: false,
      sellerDetailsError: null,
      productDetails: [],
      productDetailsLoading: false,
      productDetailsError: null,
      note: '',
    };
  },

  watch: {
    sellerId: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.invoiceId) {
          this.fetchFactoringApplications();
        }
      }
    },
    id: {
      immediate: true,
      handler(newVal) {
        this.invoiceId = newVal;
        if (newVal && this.sellerId) {
          this.fetchFactoringApplications();
        }
      }
    }
  },

  computed: {
    buyerNameInitials() {
      const name = this.requestData?.buyerName || "";
      return name
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase())
        .join("");
    },
    statusButtonStyle() {
      const status = this.requestData.status.toLowerCase();
      switch (status) {
        case "pending":
          return {
            backgroundColor: "#FEF3C7",
            color: "#92400E",
            border: "none",
            borderRadius: "6px",
          };
        case "approved":
          return {
            backgroundColor: "#D1FAE5",
            color: "#065F46",
            border: "none",
            borderRadius: "6px",
          };
        case "rejected":
          return {
            backgroundColor: "#FECACA",
            color: "#991B1B",
            border: "none",
            borderRadius: "6px",
          };
        case "suspended":
          return {
            backgroundColor: "#E0E7FF",
            color: "#3730A3",
            border: "none",
            borderRadius: "6px",
          };
        default:
          return {
            backgroundColor: "#E5E7EB",
            color: "#374151",
            border: "none",
            borderRadius: "6px",
          };
      }
    },
    allItemsChecked() {
      return this.checklistItems.every(item => item.checked);
    }
  },
  methods: {
    async fetchFactoringApplications() {
      if (!this.invoiceId || !this.sellerId) {
        console.log('Missing data:', { invoiceId: this.invoiceId, sellerId: this.sellerId });
        this.error = "Invoice number and seller ID are required";
        this.$message.error(this.error);
        return;
      }

      try {
        this.loading = true;
        console.log("Fetching factoring applications for seller:", this.sellerId);
        
        const response = await sellersService.getAllFactoringApplications(this.sellerId);

        if (response.data?.data?.results) {
          const applications = response.data.data.results;
          const application = applications.find(app => app.invoiceid.toString() === this.invoiceId.toString());
          
          if (application) {
            console.log('Raw repaymentduedate from API:', application.repaymentduedate);
            this.requestData = {
              requestId: application.id.toString(),
              invoiceNumber: application.invoiceid.toString(),
              invoiceValue: application.invoiceResponse.totalOrderValue || 0,
              requestedAmount: application.advanceamount || 0,
              buyerName: application.invoiceResponse.customerBusinessName || "",
              fee: application.feestructure || 0,
              repaymentDate: application.repaymentduedate ? new Date(application.repaymentduedate).toISOString().slice(0, 10) : null,
              paymentSchedule: "one-time", // Default value since it's not in the response
              status: application.status || "Pending",
              sellerInfo: {
                type: application.invoiceResponse.customerBusinessType || "",
                region: application.invoiceResponse.sellerCountry || "",
                disbursements: 0, // Not available in response
              },
              buyerInfo: {
                creditScore: "N/A", // Not available in response
                riskLevel: "Low Risk", // Default value
                paymentHistory: "Good", // Default value
              },
              auditLogs: [{
                author: application.createdby || "System",
                datetime: application.dateapplied ? new Date(application.dateapplied) : new Date(),
                note: "Application created",
                avatar: ""
              }],
              sellerImage: "",
              invoiceResponse: application.invoiceResponse || {},
            };
            console.log('Processed repaymentDate in requestData (after formatting):', this.requestData.repaymentDate, typeof this.requestData.repaymentDate);

            // Update compliance checklist based on application data
            this.updateComplianceChecklist(application);
            if (application.status === "Approved") {
              this.checklistItems.forEach(item => item.checked = true);
              this.saveChecklistToStorage();
            }
            this.loadChecklistFromStorage();
          } else {
            this.error = "Invoice not found in applications list";
            this.$message.error(this.error);
          }
        } else {
          this.error = "No data found for this seller";
          this.$message.error(this.error);
        }
      } catch (error) {
        console.error("Error fetching factoring applications:", error);
        this.error = error.response?.data?.message || "Failed to fetch factoring applications";
        this.$message.error(this.error);
      } finally {
        this.loading = false;
      }
    },
    async fetchSeller() {
      if (!this.sellerId) return;
      this.sellerDetailsLoading = true;
      this.sellerDetailsError = null;
      try {
        const response = await sellersService.getSeller(this.sellerId);
        if (response.data?.code === 200 && response.data.data) {
          this.sellerDetails = response.data.data;
        } else {
          this.sellerDetailsError = 'No seller data found.';
        }
      } catch (error) {
        this.sellerDetailsError = error.response?.data?.message || 'Failed to fetch seller details.';
      } finally {
        this.sellerDetailsLoading = false;
      }
    },
    formatAmount,
    exportExcell() {
      try {
        this.exportLoading = true;
        
        // Prepare the data for export
        const exportData = {
          'Request Details': [
            {
              'Request ID': this.requestData.requestId,
              'Invoice Number': this.requestData.invoiceNumber,
              'Invoice Value': this.formatAmount(this.requestData.invoiceValue),
              'Requested Amount': this.formatAmount(this.requestData.requestedAmount),
              'Buyer Name': this.requestData.buyerName,
              'Status': this.requestData.status,
              'Fee': `${this.requestData.fee}%`,
              'Repayment Date': this.requestData.repaymentDate ? new Date(this.requestData.repaymentDate).toLocaleDateString() : 'N/A',
              'Payment Schedule': this.requestData.paymentSchedule
            }
          ],
          'Seller Information': [
            {
              'Seller Type': this.requestData.sellerInfo.type,
              'Region': this.requestData.sellerInfo.region,
              'Previous Disbursements': this.requestData.sellerInfo.disbursements
            }
          ],
          'Buyer Information': [
            {
              'Credit Score': this.requestData.buyerInfo.creditScore,
              'Risk Level': this.requestData.buyerInfo.riskLevel,
              'Payment History': this.requestData.buyerInfo.paymentHistory
            }
          ],
          'Compliance Checklist': this.checklistItems.map(item => ({
            'Item': item.label,
            'Status': item.checked ? 'Verified' : 'Pending'
          }))
        };

        // Create a new workbook
        const wb = XLSX.utils.book_new();
        
        // Add each section as a separate worksheet
        Object.entries(exportData).forEach(([sheetName, data]) => {
          const ws = XLSX.utils.json_to_sheet(data);
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
        });

        // Generate the Excel file
        const fileName = `Factoring_Request_${this.requestData.requestId}_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(wb, fileName);

        this.$message.success('Export successful');
      } catch (error) {
        console.error('Export error:', error);
        this.$message.error('Failed to export data');
      } finally {
        this.exportLoading = false;
      }
    },
    showDrawer() {
      console.log("Showing drawer...");
      this.drawerVisible = true;
    },
    showInvoiceDetails() {
      if (!this.requestData.invoiceNumber) return;
      this.showInvoiceModal = true;
      this.fetchProductDetails();
    },
    handleCancel() {
      this.drawerVisible = false;
    },
    handleTermsUpdate(updatedTerms) {
      console.log('Updated terms received from drawer:', updatedTerms);
      console.log('Updated repaymentDueDate from drawer:', updatedTerms.repaymentDueDate, typeof updatedTerms.repaymentDueDate);
      // Update the request data with new terms
      this.requestData.fee = updatedTerms.fee;
      this.requestData.repaymentDate = updatedTerms.repaymentDueDate;
      this.requestData.paymentSchedule = updatedTerms.paymentSchedule;
      this.requestData.requestedAmount = updatedTerms.netPayout;
      this.requestData.calculatedFee = updatedTerms.calculatedFee;
      
      // Show success message
      this.$message.success('Financing terms updated successfully');
      
      // Close the drawer
      this.drawerVisible = false;
    },
    openInvoiceRequest(request) {
    this.selectedInvoiceRequest = request;
    this.invoiceModalVisible = true;
  },
  async handleApprove() {
    //if (this.allItemsChecked) {
    //}
      this.invoiceModalVisible = true;
  },
  async handleInvoiceDecision(data) {
    // Validate required fields
    const validationErrors = [];
    
    if (!this.sellerId) validationErrors.push('Seller ID is required');
    if (!this.requestData.requestId) validationErrors.push('Request ID is required');
    if (!this.requestData.fee) validationErrors.push('Factoring fee is required');
    if (!this.requestData.requestedAmount) validationErrors.push('Advance amount is required');
    if (!this.requestData.invoiceValue) validationErrors.push('Invoice value is required');
    if (!this.requestData.repaymentDate) validationErrors.push('Repayment due date is required');
    if (!data.disbursementMethod) validationErrors.push('Disbursement method is required');

    if (validationErrors.length > 0) {
      this.$message.error({
        content: (
          <div>
            <p>Please fill in all required fields:</p>
            <ul>
              {validationErrors.map(error => (
                <li>{error}</li>
              ))}
            </ul>
          </div>
        ),
        duration: 5
      });
      return;
    }

    try {
      this.loading = true;

      const payload = {
        sellerId: this.sellerId,
        approvalStatus: "Approved",
        id: this.requestData.requestId,
        factoringfee: Number(this.requestData.fee),
        advanceamount: Number((this.requestData.requestedAmount).toFixed(2)),
        advancerate: Number(((this.requestData.requestedAmount / this.requestData.invoiceValue) * 100).toFixed(2)),
        factoringfeeRate: Number(this.requestData.fee),
        repaymentduedate: new Date(this.requestData.repaymentDate).toISOString(),
      };
      console.log('Request Payload:', payload);

      const response = await sellersService.approveOrRejectFactoring(payload);

      console.log('Response:', response);

      if (response.status === 200) {
        this.isApproved = true;
        this.requestData.status = "Approved";
        this.$message.success("Factoring request approved successfully");
      } else {
        console.error('API Error Response:', response.data);
        this.$message.error(response.data?.message || "Failed to approve request. Please check all required fields and try again.");
      }
    } catch (error) {
      console.error("Error approving factoring request:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response,
        request: error.request,
        config: error.config
      });
      
      // Provide more specific error messages based on the error type
      if (error.response) {
        const errorMessage = error.response.data?.message || error.response.data?.error || "Server error occurred";
        this.$message.error(`Failed to approve request: ${errorMessage}`);
      } else if (error.request) {
        this.$message.error("No response received from server. Please check your internet connection.");
      } else {
        this.$message.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      this.loading = false;
      this.invoiceModalVisible = false;
    }
  },
  updateComplianceChecklist(application) {
    // Seller KYC Verification
    this.checklistItems[0].checked = application.invoiceResponse?.sellerCountry ? true : false;

    // Invoice Verification
    this.checklistItems[1].checked = application.invoiceResponse?.id ? true : false;

    // Buyer Credit Score
    this.checklistItems[2].checked = application.invoiceResponse?.customerBusinessName ? true : false;

    // Overdue Invoice Check
    const isOverdue = application.invoiceResponse?.aging > 0;
    this.checklistItems[3].checked = isOverdue ? false : true;
  },
  handleCheckboxChange(item, checked) {
    item.checked = checked;
    this.saveChecklistToStorage();
  },
  saveChecklistToStorage() {
    const key = `compliance_checklist_${this.sellerId}_${this.invoiceId}`;
    localStorage.setItem(key, JSON.stringify(this.checklistItems));
  },
  loadChecklistFromStorage() {
    const key = `compliance_checklist_${this.sellerId}_${this.invoiceId}`;
    const saved = localStorage.getItem(key);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        // Only update if structure matches
        if (Array.isArray(parsed) && parsed.length === this.checklistItems.length) {
          this.checklistItems = parsed;
        }
      } catch (e) {
        // Ignore parse errors
      }
    }
  },
  async reject() {
    try {
      // Validate required fields
      const validationErrors = [];
      
      if (!this.sellerId) validationErrors.push('Seller ID is required');
      if (!this.requestData.requestId) validationErrors.push('Request ID is required');
      if (!this.requestData.fee) validationErrors.push('Factoring fee is required');
      if (!this.requestData.requestedAmount) validationErrors.push('Advance amount is required');
      if (!this.requestData.invoiceValue) validationErrors.push('Invoice value is required');
      if (!this.requestData.repaymentDate) validationErrors.push('Repayment due date is required');

      if (validationErrors.length > 0) {
        this.$message.error({
          content: (
            <div>
              <p>Please fill in all required fields:</p>
              <ul>
                {validationErrors.map(error => (
                  <li>{error}</li>
                ))}
              </ul>
            </div>
          ),
          duration: 5
        });
        return;
      }

      this.$confirm({
        title: 'Reject Factoring Request',
        content: 'Are you sure you want to reject this factoring request?',
        okText: 'Yes, Reject',
        okType: 'danger',
        cancelText: 'No',
        onOk: async () => {
          try {
            this.loading = true;

            const payload = {
              sellerId: this.sellerId,
              approvalStatus: "Rejected",
              id: this.requestData.requestId,
              factoringfee: Number(this.requestData.fee),
              advanceamount: Number((this.requestData.requestedAmount).toFixed(2)),
              advancerate: Number(((this.requestData.requestedAmount / this.requestData.invoiceValue) * 100).toFixed(2)),
              factoringfeeRate: Number(this.requestData.fee),
              repaymentduedate: new Date(this.requestData.repaymentDate).toISOString()
            };
            console.log('Request Payload:', payload);

            const response = await sellersService.approveOrRejectFactoring(payload);

            console.log('Response:', response);

            if (response.data?.success) {
              this.requestData.status = "Rejected";
              this.$message.success("Factoring request rejected successfully");
            } else {
              console.error('API Error Response:', response.data);
              this.$message.error(response.data?.message || "Failed to reject request. Please check all required fields and try again.");
            }
          } catch (error) {
            console.error("Error rejecting factoring request:", error);
            console.error("Error details:", {
              message: error.message,
              response: error.response,
              request: error.request,
              config: error.config
            });
            
            // Provide more specific error messages based on the error type
            if (error.response) {
              const errorMessage = error.response.data?.message || error.response.data?.error || "Server error occurred";
              this.$message.error(`Failed to reject request: ${errorMessage}`);
            } else if (error.request) {
              this.$message.error("No response received from server. Please check your internet connection.");
            } else {
              this.$message.error("An unexpected error occurred. Please try again.");
            }
          } finally {
            this.loading = false;
          }
        }
      });
    } catch (error) {
      console.error("Error in reject confirmation:", error);
      this.$message.error("Failed to process rejection request. Please try again.");
    }
  },
  formatDate(date) {
    if (!date) return '';
    return new Date(date).toLocaleDateString();
  },
  formatInvoiceDate(date) {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  },
  goBack() {
    this.$router.go(-1);
  },
  async fetchProductDetails() {
    this.productDetails = [];
    this.productDetailsLoading = true;
    this.productDetailsError = null;
    try {
      const orderId = this.requestData.invoiceResponse && (this.requestData.invoiceResponse.orderId || this.requestData.invoiceResponse.id);
      if (!orderId) {
        this.productDetailsError = 'No order ID found for this invoice.';
        return;
      }
      const response = await sellersService.getSellerOrderDetails(orderId);
      if (response.data?.code === 200 && response.data.data && response.data.data.productDetails) {
        this.productDetails = response.data.data.productDetails;
      } else {
        this.productDetailsError = 'No product details found.';
      }
    } catch (error) {
      this.productDetailsError = error.response?.data?.message || 'Failed to fetch product details.';
    } finally {
      this.productDetailsLoading = false;
    }
  },
  downloadInvoice() {
    const element = this.$refs.invoiceRef;
    if (!element) return;
    const opt = {
      margin:       0.3,
      filename:     `Invoice_INV-${this.requestData.invoiceNumber}.pdf`,
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'in', format: 'a4', orientation: 'portrait' }
    };
    html2pdf().set(opt).from(element).save();
  },
  addNote() {
    if (!this.note || !this.note.trim()) {
      this.$message.warning('Please enter a note before submitting.');
      return;
    }
    // Get the current user's name from localStorage or use a fallback
    const user = JSON.parse(localStorage.getItem('user'));
    const author = user && user.name ? user.name : 'Admin User';
    this.requestData.auditLogs.unshift({
      author: author,
      datetime: new Date().toISOString(),
      note: this.note.trim(),
    });
    this.note = '';
  },
  },
  mounted() {
    // Watchers will handle data fetching when props are available
    if (this.sellerId) {
      this.fetchSeller();
    }
  },
};
</script>
<style scoped>
.invoice-modal{
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
  background-color: #fff;

}
.header {
  background-color: #fff;
  padding: 32px 56px;
  border-radius: 8px;
  
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.avatar {
  background-color: #d1fae5;
  color: #047857;
  font-size: 14px;
  font-weight: bold;
}
.label {
  font-size: 14px;
  font-weight: 400;
  color: #6b7280;
  margin-bottom: 4px;
}
.description {
  font-size: 16px;
  font-weight: 500;
  color: #000;
}

.financing-terms-card {
  background-color: #fff;
  padding: 32px 56px;
  border-radius: 8px;
  margin-top: 24px;
}
</style>
